import { PREFIX_API } from 'constants/api.const';
import {
  ApplyVoucherCodeRequestModel,
  ApplyVoucherCodeResponseModel,
  CloseBillAcceptorSessionRequestModel,
  CreateMomoTransactionRequestModel,
  CreateMomoTransactionResponseModel,
  GetBillAcceptorSessionRequestModel,
  GetBillAcceptorSessionResponseModel,
  OpenBillAcceptorSessionRequestModel,
  ResetBillAcceptorSessionRequestModel,
} from 'models/photo/bill-acceptor.model';
import qs from 'query-string';
import { baseSliceApi } from './base.slice-api';

export const paymentApi = baseSliceApi.injectEndpoints({
  endpoints: (build) => ({
    openBillAcceptorApiAction: build.mutation<
      boolean,
      OpenBillAcceptorSessionRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/billacceptor/openconnection?${qs.stringify(
          payload,
        )}`,
        method: 'POST',
      }),
      extraOptions: { maxRetries: 0 },
    }),
    getBillAcceptorApiAction: build.query<
      boolean,
      GetBillAcceptorSessionRequestModel
    >({
      query: () => ({
        url: `${PREFIX_API.API}/billacceptor/getstatus`,
      }),
      extraOptions: { maxRetries: 0 },
      transformResponse: (
        rawResult: GetBillAcceptorSessionResponseModel,
        meta,
      ) => !!rawResult?.response,
      providesTags: () => [{ type: 'BillAcceptor' as const, id: 'LIST' }],
    }),
    resetBillAcceptorApiAction: build.mutation<
      boolean,
      ResetBillAcceptorSessionRequestModel
    >({
      query: () => ({
        url: `${PREFIX_API.API}/billacceptor/reset`,
        method: 'POST',
      }),
      invalidatesTags: () => [{ type: 'BillAcceptor', id: 'LIST' }],
      extraOptions: { maxRetries: 0 },
    }),
    closeBillAcceptorApiAction: build.mutation<
      boolean,
      CloseBillAcceptorSessionRequestModel
    >({
      query: () => ({
        url: `${PREFIX_API.API}/billacceptor/closeconnection`,
        method: 'POST',
      }),
      invalidatesTags: () => [{ type: 'BillAcceptor', id: 'LIST' }],
      extraOptions: { maxRetries: 0 },
    }),
    applyVoucherCodeApiAction: build.mutation<
      ApplyVoucherCodeResponseModel,
      ApplyVoucherCodeRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/vouchers/booth/${payload?.code}/apply?price=${payload?.price}`,
        method: 'POST',
      }),
      extraOptions: { maxRetries: 0 },
    }),
    checkVoucherCodeApiAction: build.mutation<
      ApplyVoucherCodeResponseModel,
      ApplyVoucherCodeRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/vouchers/${payload?.code}/check?price=${payload?.price}`,
        method: 'POST',
      }),
      extraOptions: { maxRetries: 0 },
    }),

    createMomoTransactionApiAction: build.mutation<
      CreateMomoTransactionResponseModel,
      CreateMomoTransactionRequestModel
    >({
      query: (body) => ({
        url: `${PREFIX_API.API}/Momo`,
        method: 'POST',
        body,
      }),
      extraOptions: { maxRetries: 0 },
    }),

    createVNPayTransactionApiAction: build.mutation<
      CreateMomoTransactionResponseModel,
      CreateMomoTransactionRequestModel
    >({
      query: (body) => ({
        url: `${PREFIX_API.API}/VnPay`,
        method: 'POST',
        body,
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const {
  useLazyGetBillAcceptorApiActionQuery,
  useGetBillAcceptorApiActionQuery,
  useOpenBillAcceptorApiActionMutation,
  useResetBillAcceptorApiActionMutation,
  useCloseBillAcceptorApiActionMutation,
  useApplyVoucherCodeApiActionMutation,
  useCheckVoucherCodeApiActionMutation,
  useCreateMomoTransactionApiActionMutation,
  useCreateVNPayTransactionApiActionMutation,
} = paymentApi;

export const {
  endpoints: {
    getBillAcceptorApiAction,
    openBillAcceptorApiAction,
    resetBillAcceptorApiAction,
    closeBillAcceptorApiAction,
    applyVoucherCodeApiAction,
    checkVoucherCodeApiAction,
    createMomoTransactionApiAction,
    createVNPayTransactionApiAction,
  },
} = paymentApi;
